module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "instructions"
  }, [_vm._c('div', {
    staticClass: "title",
    class: _vm.showInstructions ? '' : 'closed',
    on: {
      "click": function($event) {
        _vm.showInstructions = !_vm.showInstructions
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.showInstructions ? 'Hide' : 'Show') + " hints & tips\n  ")]), _vm._v(" "), (_vm.showInstructions) ? _vm._c('div', {
    staticClass: "content"
  }, [_vm._t("content")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3be518f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/panels/Help.vue
// module id = 647
// module chunks = 1